export const SAMPLED_SENTRY_ERRORS = [
    {
        pattern: /^(?:TypeError|ApolloError): (?:Failed to fetch|Load failed|NetworkError when attempting to fetch resource\.?)$/,
        rate: 0.02,
        owner: '@dev/Review-FE-Infra',
        reason: 'Network-level fetch failure (offline, VPN, proxy, tab closed ' +
            'mid-request). ~22% of project volume and bursty per session, ' +
            'but the first frontend signal of a backend outage, so it is ' +
            'sampled rather than ignored.',
        ticket: 'SCAL-338696',
    },
    {
        pattern: /^ApolloError: No QUESTION_ANSWER_BOOK found with id\b/,
        rate: 0.1,
        owner: '@dev/Review-Liveboard',
        reason: 'OBJECT_NOT_FOUND (13003) on a tile load: the Liveboard was ' +
            'deleted or rewritten while a session on it was open. Most volume ' +
            'is automation deleting Liveboards mid-load, and each tile reports ' +
            'separately, but a rewritten Liveboard leaves its tiles broken ' +
            'until reload, so it is sampled rather than ignored.',
        ticket: 'SCAL-345968',
    },
];
const getEventTitle = (event) => {
    const values = event.exception?.values;
    const top = values?.[values.length - 1];
    if (!top?.value) {
        return undefined;
    }
    return top.type ? `${top.type}: ${top.value}` : top.value;
};
export const sampleSentryEvent = (event, entries = SAMPLED_SENTRY_ERRORS, random = Math.random) => {
    const title = getEventTitle(event);
    if (title === undefined) {
        return event;
    }
    const entry = entries.find(({ pattern }) => pattern.test(title));
    if (!entry) {
        return event;
    }
    if (random() >= entry.rate) {
        return null;
    }
    return { ...event, tags: { ...event.tags, sample_rate: entry.rate } };
};
//# sourceMappingURL=sentry-sampled-errors.js.map